import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {UserModel} from '../models/user.model';
import {getStatisticUrl} from '../app.urls';



@Injectable()
export class StatisticService {
    constructor(private http: HttpClient) {
    }

    getStatistic(year: number) {
        return this.http.get(getStatisticUrl()+'/'+year, );
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/statistic.service.ts